import React, { memo, useState } from 'react';
import './Styles.css';
import LoaderComponent from '../../../../Elements/ids/Loader';
import { formatMessage } from '../../../../Localization/formatMessage';
import Messages from '../../../../Localization/Messages';
import { useCustomerSearch } from './Functions';
import { InputField, InputFieldAddon, InputFieldWrapper } from '@ids/react-input-field';
import { Ui24Search, Ui32ArrowSmDown, Ui32ArrowSmUp } from '@ids/react-icons';
import { IconButton, IconButtonSize, IconButtonType, IconButtonVariant } from '@ids/react-icon-button';

const CustomerSearch = ({ onSelect, editedRate }) => {
  // this state is not shown and only used to call API
  const [query, setQuery] = useState('');
  // this state is shown to the user in the input fields, does not trigger API calls
  const [inputValue, setInputValue] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const list = useCustomerSearch(query, setIsOpen, setIsLoading);

  return (
    <div className="commission-page_customer-search-container">
      <InputFieldWrapper
        onClick={() => {
          if (!isOpen) {
            setIsOpen(true);
          }
        }}>
        <InputFieldAddon>
          <Ui24Search aria-hidden />
        </InputFieldAddon>
        <InputField
          placeholder={formatMessage(Messages.commissionPage_customerSearchPlaceholder)}
          onChange={e => {
            setQuery(e.target.value);
            setInputValue(e.target.value);
          }}
          value={inputValue}
          autoComplete="off"
        />
        <InputFieldAddon>
          <IconButton
            id="clear-button"
            aria-label="Open/close dropdown"
            type={IconButtonType.PLAIN}
            variant={IconButtonVariant.QUIET}
            size={IconButtonSize.X_SMALL}
            onClick={() => {
              if (isOpen) {
                setIsOpen(false);
              }
            }}>
            {isOpen ? <Ui32ArrowSmUp /> : <Ui32ArrowSmDown />}
          </IconButton>
        </InputFieldAddon>
      </InputFieldWrapper>

      {isOpen && (
        <div className="commission-page_customer-search-result-container">
          {isLoading ? (
            <LoaderComponent />
          ) : (
            <>
              <div className="commission-page_customer-search-result-title">
                <div>
                  {formatMessage(Messages.commissionPage_customerSearchResults)}
                  {list.length === 0 && formatMessage(Messages.commissionPage_customerSearchNotFound)}
                </div>
              </div>

              <div>
                {list?.map(customer => {
                  return (
                    <div
                      className="clickable commission-page_customer-search-result-row"
                      key={customer.customerNumber}
                      onClick={() => {
                        onSelect(customer);
                        setIsOpen(false);
                        setInputValue(customer.customerName);
                      }}>
                      <div className="commission-page_customer-search-result-first-column">
                        {customer.customerNumber}
                      </div>
                      <div className="commission-page_customer-search-result-second-column">{customer.legalNumber}</div>
                      <div>{customer.customerName}</div>
                    </div>
                  );
                })}
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default memo(CustomerSearch);
